import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "12px",
	height: "12px",
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group 5" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Design",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Overview",
				transform: "translate(-412.000000, -1757.000000)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group-Copy-11",
					transform: "translate(388.000000, 1736.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group-5",
						transform: "translate(24.000000, 21.000000)",
						children: [/* @__PURE__ */ _jsx("path", {
							d: "M6,-6.21724894e-15 C9.3137085,-6.21724894e-15 12,2.6862915 12,6 C12,7.5096105 11.4424878,8.88900706 10.5221257,9.94352744 C10.4212094,9.85561505 10.3006491,9.78454653 10.167753,9.72583756 C9.97438891,9.64029281 9.76286029,9.59556735 9.55894904,9.53482667 C9.06225717,9.38736938 8.55208841,9.27506748 8.07141257,9.08561904 C7.33428512,8.79441532 7.19463325,8.34598892 7.5657361,7.64034233 C7.99914517,6.81594868 8.33509091,5.95112635 8.43099169,5.01911818 C8.53411922,4.01601802 8.36829484,3.08947846 7.48233562,2.44496317 C6.88798511,2.01294262 6.21999998,1.94146001 5.52017813,2.03774669 C4.55472477,2.1705559 3.85627015,2.80550112 3.61114695,3.7503996 C3.44122091,4.40370373 3.44922892,5.06091402 3.65606992,5.69097654 C3.88205203,6.38021729 4.15784004,7.0559818 4.45687081,7.71690294 C4.72660399,8.31317723 4.63089852,8.73054971 4.0511968,9.01940975 C3.79572179,9.14675034 3.51837124,9.23620125 3.24492703,9.31862109 C2.78397823,9.45709422 2.31326356,9.56334159 1.85426793,9.70767395 C1.70589796,9.75431249 1.57005651,9.82476644 1.45657929,9.91943532 C0.549482592,8.86906142 0,7.49869998 0,6 C0,2.6862915 2.6862915,-6.21724894e-15 6,-6.21724894e-15 Z",
							id: "Combined-Shape",
							fill: "#4F31FF"
						}), /* @__PURE__ */ _jsx("circle", {
							id: "Oval",
							stroke: "#4F31FF",
							cx: 6,
							cy: 6,
							r: 5.5
						})]
					})
				})
			})
		})
	]
});
export default SvgProfile;
